import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Badge } from "../components/ui/badge";
import { ExternalLink, Globe2 } from "lucide-react";

export default function Sources() {
  const [data, setData] = useState(null);
  useEffect(() => { api.sources().then(setData).catch(console.error); }, []);
  if (!data) return <div className="p-8 text-zinc-500">Loading…</div>;

  return (
    <div className="p-8" data-testid="sources-page">
      <div className="mb-6">
        <div className="text-[10px] uppercase tracking-widest text-zinc-500 font-mono mb-1">Source Registry</div>
        <h1 className="text-3xl font-bold font-[Chivo] tracking-tight">Canadian Procurement Portals & Buyers</h1>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-8">
        {data.portals.map(p => (
          <div key={p.id} className="border border-zinc-200 bg-white p-5" data-testid={`source-${p.id}`}>
            <div className="flex items-start justify-between mb-2">
              <div>
                <div className="text-[10px] uppercase tracking-widest text-zinc-500 font-mono">{p.platform}</div>
                <div className="font-bold font-[Chivo] text-lg">{p.name}</div>
              </div>
              <div className="flex items-center gap-1">
                {p.login_required && (
                  <Badge className="rounded-sm bg-[#FFB000] text-black text-[10px]">LOGIN</Badge>
                )}
                <Badge variant="outline" className="rounded-sm text-[10px] font-mono">{p.country}</Badge>
              </div>
            </div>
            <a href={p.base_url} target="_blank" rel="noreferrer"
               className="text-xs text-[#002FA7] hover:underline inline-flex items-center gap-1">
              <Globe2 size={12} /> {p.base_url} <ExternalLink size={10} />
            </a>
            {p.listing_urls?.length > 0 && (
              <div className="mt-3 text-[10px] text-zinc-500 font-mono uppercase tracking-widest">
                {p.listing_urls.length} seed listing url(s)
              </div>
            )}
            {p.known_tenants?.length > 0 && (
              <div className="mt-3">
                <div className="text-[10px] text-zinc-500 font-mono uppercase tracking-widest mb-1">
                  {p.known_tenants.length} known tenants
                </div>
                <div className="flex flex-wrap gap-1">
                  {p.known_tenants.slice(0, 6).map(t => (
                    <span key={t} className="text-[10px] font-mono text-zinc-600 bg-zinc-100 px-1.5 py-0.5">
                      {t.split(".")[0]}
                    </span>
                  ))}
                  {p.known_tenants.length > 6 && (
                    <span className="text-[10px] font-mono text-zinc-500">+{p.known_tenants.length - 6} more</span>
                  )}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="mb-6">
        <h2 className="text-xl font-bold font-[Chivo] tracking-tight mb-3">Discovery Queries</h2>
        <div className="border border-zinc-200 bg-white p-5 grid grid-cols-1 md:grid-cols-2 gap-2">
          {data.discovery_queries.map((q, i) => (
            <code key={i} className="text-xs text-zinc-700 font-mono">{q}</code>
          ))}
        </div>
      </div>
    </div>
  );
}
